export const getGridStyles = () => ({
  root: {
    '& .table-container .criterion-target-table .ms-DetailsHeader [role=columnheader] .ms-DetailsHeader-cellName': {
      fontWeight: 600,
    },
  },
  image: {
    width: 16,
    height: 16,
    marginRight: 8,
  },
  name: {
    fontWeight: 600,
  },
  switch: {
    '& input:after': {
      content: 'none',
    },
    '& input': {
      width: 56,
    },
  },
});

